define([
	"dojo/_base/declare",
	"underscore",
	"csi",
	"csi/comm/PostRequest",
	"csi/core/Key",
	"csi/middleware/customView/customViewDataManagementService",
	"csi/state/rootStore",
	"csi/xml",
	"./BOMSectionMixin",
	"../_ProductAlternativeViewMixin",
	"SiteAdmin/DataSheetTable",
	"Specification/PartMaterialMixin"
], function(declare, _, csi, PostRequest, Key, {getNumGroupingLevels}, {sessionStore}, xml,
	BOMSectionMixin, _ProductAlternativeViewMixin, DataSheetTable, PartMaterialMixin) {

	const PRODUCT_TYPE_KEY = xml.queryKey(xml.ATTR_NAME, null, xml.path("Actual", "ProductType"));
	const SECTION_ID = "DSSection";

	return declare([DataSheetTable, _ProductAlternativeViewMixin, BOMSectionMixin, PartMaterialMixin], {
		allowComparison: true,

		/** @override disable DnD actions if table is grouped but here are no groups and just newly added line(s) */
		bDisableMoveActionIfNoGroups: true,

		/**
		 * @override
		 * Use CompareID except when on the main level comparing one revision vs another
		 */
		getCompareKeyForResult(qr, isSameMaster) {
			const node = qr.getNode();
			const attrId = qr.level.bMain && isSameMaster ? "SysID" : "CompareID";
			return node[attrId];
		},

		/**
		 * @override
		 * Group by BOM section by default
		 */
		onCreateDefaultCustomView(cv) {
			this.inherited(arguments);
			this.setDefaultGroupAndExpand(SECTION_ID);
		},

		/**
		 * @override
		 * Return droppable sections for current selected items
		 */
		getDroppableGroupValues: function(domNodes) {
			if (this.isGroupBySection()) {
				var urls = _.map(domNodes, function(node) {
					return this.getQueryResultByDomNode(node).url;
				}, this);
				var parentUrl = this.getQueryResultByDomNode(domNodes[0]).parentUrl;

				// make post request to get legal BOM sections for drop
				return new Promise(function(resolve, reject) {
					new PostRequest("Specification", "SectionContainerGetLegalBOMSectionsForItems")
						.addParameter("ParentURL", parentUrl)
						.addParameter("ItemURLs", urls)
						.post({}).then(function(response) {
							let groupValues = response.getResultUrls();

							// add blank section to legalGroupValues
							if (groupValues) {
								groupValues.push(csi.EMPTY_URL);
							}

							resolve(groupValues);
						});
				});
			} else {
				return this.inherited(arguments);
			}
		},

		/**
		 * @override
		 * Return true if table is grouped table and it is grouped by sections (BOM/Placements)
		 */
		isGroupBySection: function(allowTwoGroups) {
			const {groupSettings, specBuilder} = this;
			const n = getNumGroupingLevels(groupSettings);

			if (n === 0) {
				return false;
			}

			const extendedPath = specBuilder.defaultSourcePath;
			const typedKey = new Key({extendedPath, id: SECTION_ID}).typedString;
			if (groupSettings.key1 == typedKey) {
				return allowTwoGroups || (n === 1);
			}

			return false;
		},

		/**
		 * @override
		 * Update the group value of a query result
		 */
		onDndUpdateGroupValue: function(writer, qr, groupValue) {
			writer.changeNode(qr.getResultUrl()).changeAttribute(SECTION_ID, xml.ATTR_REF, groupValue);
		},

		/**
		 * If action is invoked within a group that represents a ProductType, then return its value
		 * @param {Controller} ac
		 * @return {cnl|null}
		 */
		getActionElementGroupProductType(ac) {
			const element = ac.refNode || ac.m_element;
			const qr = this.getQueryResultByDomNode(element);
			const {parentResult} = qr;

			if (parentResult && this.isProductTypeGroupWithNewActions(parentResult.level)) {
				return parentResult.groupValue;
			}

			return null;
		},

		/**
		 * Return true if given query level represents a product type and allows new actions;
		 * the product type group must be the leaf group (in other words, not the first group when 2 group levels)
		 * @param {QueryLevel} ql
		 * @return {boolean}
		 */
		isProductTypeGroupWithNewActions(ql) {
			if (sessionStore.allowBomGroupByTypeNewActions && ql.groupSpec && (ql.groupSpec.queryKey === PRODUCT_TYPE_KEY)) {
				return (this.groupSettings.key1 && !this.groupSettings.key2) || (ql.childLevel && ql.childLevel.bMain);
			}

			return false;
		},

		/**
		 * @override
		 * If grouped by Section, then find Existing Blanks row or create dummy one,
		 * otherwise create "Newly Created" group row.
		 */
		generateNewlyCreatedRow: function(newNodes, bBlanks) {
			var tr = this.newlyCreatedNode;
			if (tr) {
				return tr;
			}
			if (this.isGroupBySection()) {
				// Find "Blanks" group row
				var qrRoot = this.getQueryResult();
				var qrBlankGroups = _.filter(qrRoot.childResults, function(qr) {
					// check for result node to make sure it is not the top level report row
					return qr.bResultNode && ((qr.groupValue == csi.EMPTY_URL) || (qr.groupValue == null));
				});
				var qrBlankGroup = qrBlankGroups.length && qrBlankGroups[0];
				var blankGroupRow = qrBlankGroup && this.getRefNodeById(qrBlankGroup.id);
				if (blankGroupRow) {
					return blankGroupRow;
				} else {
					// Create dummy "Blanks" row
					return this.inherited(arguments, [newNodes, true]);
				}
			} else {
				// Create "Newly Created" row
				return this.inherited(arguments);
			}
		}
	});
});